import React from "react";
import ReactDOM from "react-dom/client"; // Cambié esto para React 18
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "../src/redux/Store";
import "./index.css";
import App from "./App";
import Login from "./screen/Login";
import Recomendaciones from "./screen/Recomendaciones";
import ListaFavoritos from "./components/Favourite";
import Favoritos from "./screen/Favoritos";
import Register from "./screen/Register";
import ProfileScreen from "./screen/Perfil";
import PrivateRoute from "./components/PrivateRoute";
import Dashboard from "./screen/dashboard";
import ClientsList from "./components/DashAdmin/clientsList";
import AgregarMovie from "./components/DashAdmin/agregarMovie";
import MovieList from "./components/DashAdmin/MoviesList";
import Header from "./components/Header/Header";
import UploadMovie from "./components/UploadMovie";
import RecoverPassword from "./screen/RecoverPassword";
import ResetPassword from "./screen/ResetPassword";
import Badges from "./screen/Badges";
import SubscriptionPlan from "./screen/SubscriptionPlan";
import MisPlanes from "./screen/MisPlanes";
import MoviePlayer from "./components/MoviePlayer";
import AdminDashboard from "./screen/AdminDashboard";
import AddMovie from "./components/AddMovie";
import MoviesList from "./components/MoviesList";
import UsersList from "./components/UsersList";
import AddUser from "./components/AddUser";
import AddPlan from "./components/DashAdmin/AddPlan";
import AnimeDetail from "./components/AnimeDetail";
import SeriesList from "./components/SeriesList";
import SeriesDetail from "./components/SeriesDetail";

const AppContent = () => {
  const location = useLocation();
  const hiddenHeaderRoutes = [
    "/login",
    "/register",
    "/recover-password",
    "/reset-password",
  ];

  return (
    <>
      {!hiddenHeaderRoutes.includes(location.pathname) && <Header />}

      <Routes>
        {/* Ruta principal redirige a Home en vez de login */}
        <Route
          path="/"
          element={<Navigate to="/home" />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/recover-password" element={<RecoverPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/home" element={<App />} />
        <Route path="/subscriptionplan" element={<SubscriptionPlan />} />

        <Route
          path="/feedback"
          element={
            <PrivateRoute>
              <Recomendaciones />
            </PrivateRoute>
          }
        />
        <Route path="/favoritos" element={<Favoritos />} />
        <Route path="/badges" element={<Badges />} />
        <Route path="/misplanes" element={<MisPlanes />} />
        <Route 
          path="/profile" 
          element={
            <PrivateRoute>
              <ProfileScreen />
            </PrivateRoute>
          } 
        />
        {/* <Route path="/admin" element={<Dashboard />} /> */}
        <Route 
          path="/admin" 
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/admin/users" 
          element={
            <PrivateRoute>
              <UsersList />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/admin/movies" 
          element={
            <PrivateRoute>
              <MoviesList />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/admin/subscriptionplan" 
          element={
            <PrivateRoute>
              <AddPlan />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/movies/new" 
          element={
            <PrivateRoute>
              <AddMovie />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/users/new" 
          element={
            <PrivateRoute>
              <AddUser />
            </PrivateRoute>
          } 
        />

        <Route 
          path="/clientes" 
          element={
            <PrivateRoute>
              <ClientsList />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/movies/list" 
          element={
            <PrivateRoute>
              <MovieList />
            </PrivateRoute>
          } 
        />
        {/* <Route path="/movies/new" element={<UploadMovie />} /> */}
        <Route path="/movies/movie/:id" element={<MoviePlayer />} />
        <Route path="/movies/movie" element={<MoviePlayer />} />
        <Route path="/animes/:id" element={<AnimeDetail />} />
        
        {/* Rutas para Series */}
        <Route 
          path="/series" 
          element={<SeriesList />} 
        />
        <Route 
          path="/series/:id" 
          element={<SeriesDetail />}
        />
        <Route 
          path="/series/new" 
          element={
            <PrivateRoute>
              <AddMovie />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/series/list" 
          element={
            <PrivateRoute>
              <MovieList />
            </PrivateRoute>
          } 
        />
      </Routes>
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <Router>
      <AppContent />
    </Router>
  </Provider>
);
